import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

@Injectable()
export class MiddlemanService {

    private data: any;

    constructor(private router: Router) { }

    navigate(route: any, data: any) {
        console.log('middleman navigate')
        this.data = data;
        this.router.navigate([route]);
    };

    navigateWithParams(routeCommands: any[], queryParams: any, data: any) {
        this.data = data;
        this.router.navigate(routeCommands, { queryParams: queryParams });
    };

    clear() {
        delete this.data;
    }

    getData() {
        return this.data;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/middleman.service.ts